export const SETTEXT = 'SETTEXT'
export const WORKERLOOKUP = 'WORKERLOOKUP'
export const FETCH = 'FETCH'
